import { useEffect, useState, useContext } from "react";
import api from "../api";
import "./home.css";
import { Link } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { resolveMediaUrl } from '../utils/url';

export default function AdminPending() {
  const [list, setList] = useState([]);
  const [mentorApps, setMentorApps] = useState([]);
  const [mentorHistory, setMentorHistory] = useState([]);
  const [showMentorHistory, setShowMentorHistory] = useState(false);
  const [selectedHistoryApp, setSelectedHistoryApp] = useState(null);
  const [rejectOpen, setRejectOpen] = useState({}); // { [id]: true }
  const [rejectReason, setRejectReason] = useState({}); // { [id]: 'text' }
  const { user } = useContext(UserContext);
  const [actionError, setActionError] = useState('');

  const load = async () => {
    const { data } = await api.get("/admin/pending");
    setList(data);
    try {
      const res = await api.get('/admin/mentor-applications');
      const items = Array.isArray(res?.data?.items) ? res.data.items : [];
      setMentorApps(items);
    } catch {
      setMentorApps([]);
    }
  };
  const approve = async (id) => { await api.post(`/admin/${id}/approve`); await load(); };
  const reject  = async (id) => { await api.post(`/admin/${id}/reject`);  await load(); };
  const approveMentor = async (id) => {
    setActionError('');
    try {
      await api.post(`/admin/mentor-applications/${id}/approve`);
      await load();
    } catch (e) {
      setActionError(e?.response?.data?.error || 'Aktion fehlgeschlagen');
    }
  };
  const rejectMentor = async (id) => {
    setActionError('');
    const reason = (rejectReason[id] || '').trim();
    if (!reason) return;
    try {
      await api.post(`/admin/mentor-applications/${id}/reject`, { reason });
      await load();
    } catch (e) {
      setActionError(e?.response?.data?.error || 'Aktion fehlgeschlagen');
    }
  };
  const canManageMentor = Array.isArray(user?.roles) && (user.roles.includes('admin') || user.roles.includes('owner') || user.roles.includes('moderator'));

  useEffect(() => { load(); }, []);
  return (
    <div className="home-page">
  <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Ausstehende Anmeldungen</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>
          Hier siehst du alle Nutzer, die auf Freischaltung warten.<br/>
          Du kannst Anfragen direkt genehmigen oder ablehnen.
        </p>
      </section>

  <section style={{width:'100%',maxWidth:'1200px',margin:'0 auto',padding:0}}>
        <div className="highlight-card" style={{gap:18, padding:32, width:'100%'}}>
          {list.length === 0 && <p style={{opacity:.7}}>Keine offenen Anfragen.</p>}
          {list.map(u => (
            <div key={u.id} style={{display:"grid",gridTemplateColumns:"1fr auto auto",gap:12,alignItems:"start",padding:"16px 0",borderBottom:"1px dashed rgba(255,255,255,0.08)"}}>
              <div style={{minWidth:0}}>
                <div style={{marginBottom:6}}>
                  <b>{u.username}</b>
                  {u.displayName && u.displayName !== u.username && (
                    <span style={{opacity:.85}}> — {u.displayName}</span>
                  )}
                  {" "}— {u.email} <span style={{opacity:.7}}>({u.status})</span>
                </div>
                <div style={{marginBottom:8}}>
                  <span style={{opacity:.7,fontSize:12}}>Geworben durch: </span>
                  {u.referrer
                    ? (
                      <span style={{fontSize:12,fontWeight:600}} title={u.referrer.displayName && u.referrer.displayName !== u.referrer.username ? u.referrer.displayName : ''}>
                        {u.referrer.displayName && u.referrer.displayName !== u.referrer.username ? `${u.referrer.displayName} (@${u.referrer.username})` : `@${u.referrer.username}`}
                      </span>
                    )
                    : <span style={{fontSize:12,opacity:.5}}>-</span>
                  }
                </div>
                {/* Registrierungsdetails */}
                {(() => {
                  const reg = (u.settings && u.settings.registration) ? u.settings.registration : {};
                  const rows = [
                    reg.firstName ? { label: 'Vorname', value: reg.firstName } : null,
                    reg.twitch ? { label: 'Twitch', value: reg.twitch } : null,
                    reg.tiktok ? { label: 'TikTok', value: reg.tiktok } : null,
                    reg.youtube ? { label: 'YouTube', value: reg.youtube } : null,
                    reg.instagram ? { label: 'Instagram', value: reg.instagram } : null,
                    reg.discoverySource ? { label: 'Herkunft', value: reg.discoverySource } : null,
                    reg.acceptedTermsAt ? { label: 'AGB/DSGVO bestätigt', value: new Date(reg.acceptedTermsAt).toLocaleString() } : null,
                  ].filter(Boolean);
                  if (!rows.length) return null;
                  return (
                    <div style={{display:'flex',flexWrap:'wrap',gap:10,opacity:.9}}>
                      {rows.map((r, idx) => (
                        <div key={idx} style={{background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,padding:'6px 10px',fontSize:13}}>
                          <span style={{opacity:.8}}>{r.label}: </span>
                          <span style={{fontWeight:600}}>{r.value}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
              <button className="hero-btn-primary" onClick={()=>approve(u.id)}>Freischalten</button>
              <button className="hero-btn-secondary" onClick={()=>reject(u.id)}>Ablehnen</button>
            </div>
          ))}
        </div>
      </section>

      {/* Mentor-Bewerbungen */}
      <section style={{width:'100%',maxWidth:'1200px',margin:'24px auto 0',padding:0}}>
        <div className="highlight-card" style={{gap:18, padding:32, width:'100%'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,marginBottom:8}}>
            <h2 className="highlight-title" style={{marginTop:0,marginBottom:0}}>Mentor-Bewerbungen (offen)</h2>
            {canManageMentor && (
              <button
                type="button"
                onClick={async () => {
                  if (!showMentorHistory && mentorHistory.length === 0) {
                    try {
                      const res = await api.get('/admin/mentor-applications/history');
                      const items = Array.isArray(res?.data?.items) ? res.data.items : [];
                      setMentorHistory(items);
                    } catch {
                      setMentorHistory([]);
                    }
                  }
                  setShowMentorHistory(v => !v);
                }}
                className="hero-btn-secondary"
                style={{padding:'6px 12px', fontSize:13}}
              >
                {showMentorHistory ? 'Historie ausblenden' : 'Historie ansehen'}
              </button>
            )}
          </div>
          {actionError && (
            <div style={{background:'rgba(231,76,60,0.15)',border:'1px solid #e74c3c',color:'#ffb4a9',padding:'8px 12px',borderRadius:8,marginBottom:12,fontSize:13}}>
              {actionError}
            </div>
          )}
          {!showMentorHistory && mentorApps.length === 0 && <p style={{opacity:.7}}>Keine offenen Bewerbungen.</p>}
          {!showMentorHistory && mentorApps.map(app => {
            const avatarUrl = resolveMediaUrl(app.user.avatarUrl || '/avatars/default-avatar.png');
            return (
            <div key={app.id} style={{display:'grid', gap:12, padding:'20px 0', borderBottom:'1px dashed rgba(255,255,255,0.08)'}}>
              <div style={{display:'flex',alignItems:'center',gap:14,flexWrap:'wrap'}}>
                <img src={avatarUrl} alt="Avatar" style={{width:56,height:56,borderRadius:'50%',objectFit:'cover',border:'2px solid #32CD89',background:'#111'}} />
                <div style={{display:'flex',flexDirection:'column',minWidth:180}}>
                  <div style={{fontWeight:700, fontSize:16}}>
                    <Link to={`/u/${app.user.id}`} style={{textDecoration:'none',color:'#fff'}}>{app.user.displayName || app.user.username}</Link>
                  </div>
                  <div style={{opacity:.8,fontSize:13}}>@{app.user.username}</div>
                  <div style={{opacity:.6,fontSize:11}}>Eingereicht: {new Date(app.createdAt).toLocaleString()}</div>
                </div>
                <div style={{marginLeft:'auto', fontSize:12, opacity:.75, display:'flex', flexDirection:'column', alignItems:'flex-end', gap:6}}>
                  <span>Status: {app.status}</span>
                  {canManageMentor && (
                    <div style={{display:'flex',gap:10,flexWrap:'wrap',justifyContent:'flex-end'}}>
                      <button onClick={()=>approveMentor(app.id)} className="hero-btn-primary" style={{padding:'6px 14px'}}>Genehmigen</button>
                      {!rejectOpen[app.id] && (
                        <button onClick={()=>setRejectOpen(o=>({...o,[app.id]:true}))} className="hero-btn-secondary" style={{padding:'6px 14px'}}>Ablehnen</button>
                      )}
                    </div>
                  )}
                </div>
                {rejectOpen[app.id] && canManageMentor && (
                  <div style={{flexBasis:'100%', marginTop:8}}>
                    <label style={{display:'block', fontSize:12, opacity:.75, marginBottom:4}}>Ablehnungsgrund (Pflicht)</label>
                    <textarea
                      value={rejectReason[app.id] || ''}
                      onChange={e=>setRejectReason(r=>({...r,[app.id]:e.target.value}))}
                      rows={3}
                      style={{width:'100%', background:'rgba(255,255,255,0.05)', color:'#fff', border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:10, resize:'vertical'}}
                      placeholder="Kurz begründen, warum abgelehnt."
                    />
                    <div style={{display:'flex',gap:10,marginTop:8}}>
                      <button onClick={()=>rejectMentor(app.id)} disabled={!rejectReason[app.id] || !rejectReason[app.id].trim()} className="hero-btn-secondary" style={{padding:'6px 14px', background:'#e74c3c', borderColor:'#e74c3c'}}>Ablehnung speichern</button>
                      <button onClick={()=>{ setRejectOpen(o=>{ const c={...o}; delete c[app.id]; return c; }); setRejectReason(r=>{ const c={...r}; delete c[app.id]; return c; }); }} style={{padding:'6px 14px', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.18)', borderRadius:8, cursor:'pointer'}}>Abbrechen</button>
                    </div>
                  </div>
                )}
              </div>
              <div style={{display:'grid',gap:8}}>
                <Row label="Motivation" value={app.why} />
                <Row label="Unterstützungsbereiche" value={(app.supportAreas||[]).join(', ')} />
                {app.supportOther ? <Row label="Sonstiges" value={app.supportOther} /> : null}
                {app.experience ? <Row label="Erfahrung" value={app.experience} /> : null}
                {Array.isArray(app.availability) && app.availability.length ? <Row label="Verfügbarkeit" value={app.availability.join(', ')} /> : null}
                <Row label="Kurzvorstellung" value={app.intro} />
                {app.notes ? <Row label="Bemerkungen" value={app.notes} /> : null}
              </div>
              {/* Kriterien */}
              <div style={{display:'grid',gap:8, marginTop:6}}>
                <Crit ok={app.eligibility?.membershipWeeksOk} label={`Mitgliedschaft ≥ ${app.eligibility?.thresholds?.MIN_WEEKS || 8} Wochen`} value={`${app.eligibility?.membershipWeeks ?? 0} Wochen`} />
                <Crit ok={app.eligibility?.pointsOk} label={`All-Time-Punkte ≥ ${(app.eligibility?.thresholds?.MIN_POINTS||50000).toLocaleString('de-DE')}`} value={`${app.eligibility?.allTimePoints ?? 0}`} />
                <Crit ok={app.eligibility?.invitedOk} label={`Aktive Einladungen ≥ ${app.eligibility?.thresholds?.MIN_INVITED || 2}`} value={`${app.eligibility?.invitedActiveCount ?? 0}`} />
                <div style={{display:'flex', gap:12, flexWrap:'wrap', marginTop:4}}>
                  <Badge ok={!!app.confirmations?.confirmActiveParticipation}>Aktive Teilnahme bestätigt</Badge>
                  <Badge ok={!!app.confirmations?.confirmNoRuleBreaches}>Keine Regelverstöße (8 Wochen)</Badge>
                  <Badge ok={!!app.confirmations?.acceptRules}>Regeln akzeptiert</Badge>
                </div>
              </div>
            </div>
          )})}

          {showMentorHistory && (
            <div style={{marginTop:16}}>
              {mentorHistory.length === 0 && (
                <p style={{opacity:.7}}>Keine Bewerbungs-Historie vorhanden.</p>
              )}
              {mentorHistory.map(app => {
                const avatarUrl = resolveMediaUrl(app.user.avatarUrl || '/avatars/default-avatar.png');
                const statusColor = app.status === 'approved'
                  ? '#32CD89'
                  : app.status === 'rejected'
                  ? '#e74c3c'
                  : '#fbbf24';
                return (
                  <div key={`hist-${app.id}`} style={{display:'grid', gap:12, padding:'16px 0', borderTop:'1px dashed rgba(255,255,255,0.08)'}}>
                    <div style={{display:'flex',alignItems:'center',gap:14,flexWrap:'wrap'}}>
                      <img src={avatarUrl} alt="Avatar" style={{width:40,height:40,borderRadius:'50%',objectFit:'cover',border:'2px solid #555',background:'#111'}} />
                      <div style={{display:'flex',flexDirection:'column',minWidth:180}}>
                        <div style={{fontWeight:600, fontSize:14}}>
                          <Link to={`/u/${app.user.id}`} style={{textDecoration:'none',color:'#fff'}}>{app.user.displayName || app.user.username}</Link>
                        </div>
                        <div style={{opacity:.8,fontSize:11}}>@{app.user.username}</div>
                      </div>
                      <div style={{marginLeft:'auto', fontSize:12, display:'flex', flexDirection:'column', alignItems:'flex-end', gap:4}}>
                        <span style={{opacity:.7}}>Eingereicht: {new Date(app.createdAt).toLocaleString()}</span>
                        <span style={{color:statusColor, fontWeight:600, fontSize:12}}>Status: {app.status}</span>
                        {app.status === 'rejected' && app.rejectionReason && (
                          <span style={{maxWidth:360, textAlign:'right', fontSize:11, opacity:.85}}>
                            Ablehnungsgrund: {app.rejectionReason}
                          </span>
                        )}
                        <button
                          type="button"
                          onClick={() => setSelectedHistoryApp(app)}
                          style={{marginTop:6,padding:'4px 10px',borderRadius:999,border:'1px solid rgba(148,163,184,0.8)',background:'rgba(15,23,42,0.9)',color:'#e5e7eb',fontSize:11,cursor:'pointer'}}
                        >
                          Details anzeigen
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {showMentorHistory && selectedHistoryApp && (
        <HistoryDetailModal
          app={selectedHistoryApp}
          onClose={() => setSelectedHistoryApp(null)}
        />
      )}
    </div>
  );
}

function HistoryDetailModal({ app, onClose }) {
  if (!app) return null;
  const avatarUrl = resolveMediaUrl(app.user.avatarUrl || '/avatars/default-avatar.png');
  const statusColor = app.status === 'approved'
    ? '#32CD89'
    : app.status === 'rejected'
    ? '#e74c3c'
    : '#fbbf24';
  return (
    <div
      style={{
        position:'fixed',
        inset:0,
        background:'rgba(0,0,0,0.6)',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        zIndex:60,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background:'#020617',
          borderRadius:12,
          padding:20,
          width:'100%',
          maxWidth:720,
          maxHeight:'80vh',
          overflow:'auto',
          border:'1px solid rgba(148,163,184,0.7)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <h3 style={{margin:0,fontSize:18}}>Mentor-Bewerbung – Details</h3>
          <button
            type="button"
            onClick={onClose}
            style={{border:'none',background:'transparent',color:'#9ca3af',cursor:'pointer',fontSize:20,lineHeight:1}}
          >
            ×
          </button>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:14,marginBottom:16,flexWrap:'wrap'}}>
          <img src={avatarUrl} alt="Avatar" style={{width:56,height:56,borderRadius:'50%',objectFit:'cover',border:'2px solid #4b5563',background:'#111'}} />
          <div style={{display:'flex',flexDirection:'column',minWidth:180}}>
            <div style={{fontWeight:700,fontSize:16}}>{app.user.displayName || app.user.username}</div>
            <div style={{opacity:.8,fontSize:13}}>@{app.user.username}</div>
            <div style={{opacity:.6,fontSize:11}}>Eingereicht: {new Date(app.createdAt).toLocaleString()}</div>
          </div>
          <div style={{marginLeft:'auto',textAlign:'right',fontSize:12}}>
            <div style={{color:statusColor,fontWeight:600}}>Status: {app.status}</div>
            {app.status === 'rejected' && app.rejectionReason && (
              <div style={{marginTop:4,maxWidth:260,fontSize:11,opacity:.9}}>Ablehnungsgrund: {app.rejectionReason}</div>
            )}
          </div>
        </div>
        <div style={{display:'grid',rowGap:10}}>
          <Row label="Motivation" value={app.why} />
          <Row label="Unterstützungsbereiche" value={(app.supportAreas || []).join(', ')} />
          {app.supportOther ? <Row label="Sonstiges" value={app.supportOther} /> : null}
          {app.experience ? <Row label="Erfahrung" value={app.experience} /> : null}
          {Array.isArray(app.availability) && app.availability.length ? (
            <Row label="Verfügbarkeit" value={app.availability.join(', ')} />
          ) : null}
          <Row label="Kurzvorstellung" value={app.intro} />
          {app.notes ? <Row label="Bemerkungen" value={app.notes} /> : null}
        </div>
        <div style={{marginTop:14,borderTop:'1px solid rgba(148,163,184,0.5)',paddingTop:10}}>
          <div style={{fontSize:13,opacity:.8,marginBottom:6}}>Kriterien & Bestätigungen</div>
          <div style={{display:'grid',rowGap:8}}>
            <Crit
              ok={app.eligibility?.membershipWeeksOk}
              label={`Mitgliedschaft ≥ ${app.eligibility?.thresholds?.MIN_WEEKS || 8} Wochen`}
              value={`${app.eligibility?.membershipWeeks ?? 0} Wochen`}
            />
            <Crit
              ok={app.eligibility?.pointsOk}
              label={`All-Time-Punkte ≥ ${(app.eligibility?.thresholds?.MIN_POINTS || 50000).toLocaleString('de-DE')}`}
              value={`${app.eligibility?.allTimePoints ?? 0}`}
            />
            <Crit
              ok={app.eligibility?.invitedOk}
              label={`Aktive Einladungen ≥ ${app.eligibility?.thresholds?.MIN_INVITED || 2}`}
              value={`${app.eligibility?.invitedActiveCount ?? 0}`}
            />
            <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:4}}>
              <Badge ok={!!app.confirmations?.confirmActiveParticipation}>Aktive Teilnahme bestätigt</Badge>
              <Badge ok={!!app.confirmations?.confirmNoRuleBreaches}>Keine Regelverstöße (8 Wochen)</Badge>
              <Badge ok={!!app.confirmations?.acceptRules}>Regeln akzeptiert</Badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div style={{display:'grid', gridTemplateColumns:'180px 1fr', gap:12, alignItems:'start'}}>
      <div style={{opacity:.7}}>{label}</div>
      <div style={{whiteSpace:'pre-wrap'}}>{value}</div>
    </div>
  );
}

function Crit({ ok, label, value }) {
  const base = { width:18, height:18, borderRadius:'50%', display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700 };
  return (
    <div style={{display:'grid', gridTemplateColumns:'20px 1fr auto', gap:10, alignItems:'center'}}>
      <span style={{...base, background: ok ? '#32CD89':'#e74c3c', color:'#fff'}}>{ok ? '✔':'✖'}</span>
      <div>{label}</div>
      <div style={{opacity:.75, fontSize:12}}>{value}</div>
    </div>
  );
}

function Badge({ ok, children }) {
  return (
    <span style={{padding:'4px 8px', borderRadius:999, border:`1px solid ${ok ? '#32CD89':'rgba(255,255,255,0.25)'}`, background: ok ? 'rgba(50,205,137,0.18)':'rgba(255,255,255,0.06)', fontSize:12}}>{children}</span>
  );
}
